import styled from 'styled-components';
import { Box, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/ItemDetailMetaQS';
import { InfoListContainer, InfoListRow } from './shared';

TEXT.DEFINE({
  /** Label for project access */
  access: 'Project Access',
  /** Label for created by */
  createdBy: 'Created By',
  /** Label for date created */
  dateCreated: 'Date Created',
  /** Label for date uploaded */
  dateUploaded: 'Date Uploaded',
  /** Label for file type */
  fileType: 'File Type',
  /** Label for folder access */
  folderAccess: 'Folder Access',
  /** Label for number of items */
  items: 'Number of Items',
  /** Label for project */
  project: 'Project',
  /** Label for size */
  size: 'Size',
  /** Label for status */
  status: 'Status',
  /** Label for storage */
  storage: 'Storage',
  /** Label for uploaded by */
  uploadedBy: 'Uploaded By',
  /** Label for users */
  users: 'Users',
  /** Label for workspace */
  workspace: 'Workspace',
});

type ItemDetailMetaProps = {
  itemMeta: {
    access?: string | null;
    createdBy?: string | null;
    dateCreated?: string | null;
    dateUploaded?: string | null;
    fileType?: string | null;
    folderAccess?: string | null;
    items?: number | null;
    project?: string | null;
    size?: string | null;
    status?: string | null;
    storage?: string | null;
    uploadedBy?: string | null;
    users?: number | null;
    workspace?: string | null;
  };
};

export const ItemDetailMeta = ({ itemMeta }: ItemDetailMetaProps) => {
  return (
    <InfoListContainer>
      {Object.entries(itemMeta)
        .filter(([__key, value]) => value !== null && value !== undefined)
        .map(([key, value]) => {
          const text = TEXT[key as keyof typeof TEXT] as string;

          return (
            <InfoListRow key={key}>
              <MetaTitleWrapper>
                <Box paddingY={4}>
                  <Text
                    color="primary"
                    enableTooltip={true}
                    truncate={true}
                    variant="secondary"
                  >
                    {text}
                  </Text>
                </Box>
              </MetaTitleWrapper>
              <MetaValueWrapper>
                <Box paddingY={4}>
                  <Text color="tertiary" variant="secondary">
                    {value}
                  </Text>
                </Box>
              </MetaValueWrapper>
            </InfoListRow>
          );
        })}
    </InfoListContainer>
  );
};

const MetaTitleWrapper = styled.div`
  flex: 0 0 40%;
  min-width: 0;
`;

const MetaValueWrapper = styled.div`
  flex: 0 1 auto;
  min-width: 0;
  text-align: right;
`;
